export default [
  {
    path: "/admin/users",
    component: () => import("@/views/admin/users/UsersView.vue"),
    meta: {
      authentication: { required: true },
      useNewContainer: true,
      hideNavShadow: true,
    },
  },
  {
    path: "/businesses",
    component: () => import("@/views/admin/businesses/BusinessesView.vue"),
    meta: {
      authentication: { required: true },
      useNewContainer: true,
      hideNavShadow: true,
    },
  },
  {
    path: "/admin/businesses/:businessId/business",
    props: true,
    component: () => import("@/views/admin/business/AdminBusinessView.vue"),
    children: [
      {
        path: "subscription",
        props: true,
        component: () => import("@/views/admin/business/AdminBusinessView.vue"),
        meta: {
          component: "AdminBusinessSubscription",
          authentication: { required: true },
          authorization: { roles: ["predictile_administrator", "predictile_management"] },
          useNewContainer: true,
          hideNavShadow: true,
        },
      },
      {
        path: "settings",
        props: true,
        component: () => import("@/views/admin/business/components/AdminBusinessSettings.vue"),
        meta: {
          component: "AdminBusinessSettings",
          authentication: { required: true },
          authorization: { roles: ["predictile_administrator", "predictile_management"] },
          useNewContainer: true,
          hideNavShadow: true,
        },
      },
      {
        path: "payments",
        props: true,
        component: () => import("@/views/admin/business/AdminBusinessView.vue"),
        meta: {
          component: "BusinessPaymentHistory",
          authentication: { required: true },
          authorization: { roles: ["predictile_administrator", "predictile_management"] },
          useNewContainer: true,
          hideNavShadow: true,
        },
      },
      {
        path: "connection",
        props: true,
        component: () => import("@/views/admin/business/AdminBusinessView.vue"),
        meta: {
          component: "BusinessStripeConnection",
          authentication: { required: true },
          authorization: { roles: ["predictile_administrator", "predictile_management"] },
          useNewContainer: true,
          hideNavShadow: true,
        },
      },
    ],
  },
  {
    path: "/admin/integrations",
    props: false,
    component: () => import("@/views/admin/integrations/AdminIntegrationsView.vue"),
    meta: {
      authentication: { required: true },
      authorization: { roles: ["predictile_administrator", "predictile_management"] },
      useNewContainer: true,
    },
  },
  {
    path: "/admin/services",
    component: () => import("@/views/admin/services/AdminServicesView.vue"),
    meta: {
      authentication: { required: true },
      authorization: { roles: ["predictile_administrator", "predictile_management"] },
      useNewContainer: true,
    },
  },
  {
    path: "/admin/email",
    component: () => import("@/views/admin/email/EmailTemplatesView.vue"),
    meta: {
      authentication: { required: true },
      authorization: { roles: ["predictile_administrator", "predictile_management", "predictile_operations"] },
      useNewContainer: true,
    },
  },
  {
    path: "/admin/subscription-reconcile",
    component: () => import("@/views/admin/subscription-reconcile/SubscriptionReconcileView.vue"),
    meta: {
      authentication: { required: true },
      authorization: { roles: ["predictile_administrator", "predictile_management", "predictile_operations"] },
      useNewContainer: true,
    },
  },
];
